import React from "react";

import TextInput from "../../shared/components/forms/TextInput";
import Button from "../../shared/components/forms/Button";

export default function UserForm({
  first_name,
  last_name,
  onChange,
  onSubmit,
  onFocusFirstName = () => {},
  onFocusLastName = () => {},
}) {
  return (
    <div className="ds-card">
      <section className="cardSection">
        <TextInput
          label="First Name"
          name="first_name"
          value={first_name}
          onChange={onChange}
          onFocus={onFocusFirstName}
        />
        <TextInput
          label="Last Name"
          name="last_name"
          value={last_name}
          onChange={onChange}
          onFocus={onFocusLastName}
        />
      </section>
      <Button
        className="--full"
        onClick={onSubmit}
        label="Save Changes"
        test="save-changes-user-name"
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/features/user/components/UserForm.js